import firebase from "firebase/compat/app"
import "firebase/auth"

export const auth = firebase.initializeApp({
    apiKey: "AIzaSyATUhVGJQE_8dlZeOt_Oxwi936-t5V9Teg",
    authDomain: "unichat-64f22.firebaseapp.com",
    projectId: "unichat-64f22",
    storageBucket: "unichat-64f22.appspot.com",
    messagingSenderId: "893168619422",
    appId: "1:893168619422:web:9354e2fa642a5d4e8f908f"
}).auth();

  export {firebase}